import React, { Component } from "react";

class HomeTwinTreatment extends  Component{
    render()
    {
        return (
            <section className="treatment-offers-sec">
            <div className="container-fluid p-0">
                <div className="row no-gutters">
                    <div className="col-md-6">
                        <div className="text-box wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                            <h3>Sign up to offer Twin Treatment</h3>
                            <p>India is the world’s diabetes capital with more than 100 million patients who are diabetic and prediabetic. They are looking for doctors like you to regain their life. With Twin, you have the power of data and technology in your hands - you can offer superior health outcomes to more patients with less manual effort.</p>
                            <p>Built by global experts and embraced by India’s leading doctors, Twin is the world's most advanced, scientific approach to diabetes reversal. Embrace the future of diabetes treatment.</p>
                            {/* <a href="#">Sign-up for Demo</a> */}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="image-holder wow fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                            <img data-src="https://res.cloudinary.com/image/upload/v1604991959/NewHome/treatment-img-min_eeatdw.png" alt="" className="img-fluid lazyload" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        )
    }

}
export default HomeTwinTreatment